function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M40.35,14.88c-15.22,0-27.56,12.34-27.56,27.56s12.34,27.56,27.56,27.56,27.56-12.34,27.56-27.56-12.34-27.56-27.56-27.56ZM53.4,44.91l-18.12,10.46c-1.9,1.1-4.27-.27-4.27-2.47v-20.92c0-2.19,2.37-3.56,4.27-2.47l18.12,10.46c1.9,1.1,1.9,3.84,0,4.94Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/LastPlayed-active.9d3fb7fd.svg";
export { SvgComponent as ReactComponent };